import styles from "./InputChecklist.module.css"

function InputChecklist({ itemKey, onChangeValue, onChangeDescricao, item }) {
    return (
        <tr>
            <td>
                <span>{item.item}</span>
            </td>
            <td>
                <input type="radio"
                    name={itemKey}
                    value={false}
                    checked={item.problema === false}
                    onChange={() => onChangeValue(item.key, false)}
                />
            </td>
            <td>
                <input
                    type="radio"
                    name={itemKey}
                    value={true}
                    checked={item.problema === true}
                    onChange={() => onChangeValue(item.key, true)}
                />
            </td>
            <td>
                {item.problema && 
                    <textarea 
                        className={styles.describe} 
                        placeholder="Descreva a problema..." 
                        value={item.descricao}
                        onChange={(e) => onChangeDescricao(item.key, e.target.value)} 
                    />
                }
            </td>
        </tr>
    )
}

export default InputChecklist;